import React from "react";

const SvgArrow = props => {
  const { cls, children } = props;
  return <div className={`svg-arrow is-hidden-touch ${cls}`}>{children}</div>;
};

export default SvgArrow;
